import { render, staticRenderFns } from "./hotRead.vue?vue&type=template&id=edf98d78&scoped=true&"
import script from "./hotRead.vue?vue&type=script&lang=js&"
export * from "./hotRead.vue?vue&type=script&lang=js&"
import style0 from "./hotRead.vue?vue&type=style&index=0&id=edf98d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf98d78",
  null
  
)

export default component.exports